/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { AGE_VERIFICATION_STATUS, MINIMUM_DISTANCE, deliveryId, uniqueID } from '../../utils/constants';
import { authHeaders, axiosInstance, cleanText, encodeValue, formatRupiah, isEmptyData, logError, sendAnalyticsCustomEvent, sendAnalyticsEvent, sendAnalyticsPageView, trackMetaPixelEvent } from '../../utils/helper';
import Loader from '../../components/Loader/index';
import { ArrowLeftIcon, StarIcon } from '@heroicons/react/24/solid';
import { BuildingStorefrontIcon, HeartIcon } from '@heroicons/react/24/outline';
import { BikeIcon, DiscountIcon, LoaderIcon, TagIcon, WishtlingIcon } from '../../utils/svg';
import Footer from '../../components/Footer';
import qs from 'qs';
import ProductDetail, { ProductGrid } from '../../components/Product';
import ProductSimple from '../../components/Product/simple';
import { BottomSheet } from 'react-spring-bottom-sheet';
import ProductCombo from '../../components/Product/combo';
import { useDispatch, useSelector } from 'react-redux';
import useToast from '../../components/Toast';
import ImageLoader from '../../components/ImageLoader';
import NoOutlet from '../../components/Outlet/NoOutlet';
import useNavigation from '../../hook/useNavigation';
import useScroll from '../../hook/useScroll';
import { CouponVoucherGlobal, CouponVoucherGlobalList } from 'components/Outlet/VoucherGlobal';
import VoucherGlobalDetail from '../../components/VoucherGlobal/VoucherDetail';
import Address from '../../components/address';
import SearchMenu from '../../components/Outlet/Search';
import Header from '../../components/Outlet/Header';
import Detail from '../../components/Outlet/Detail';
import { handleGetStoreDetail } from 'store/reducers/outlet';
import Tags from 'components/Outlet/Tags';
import useNearBottom from 'hook/useNearBottom';
import { getOrderTypeOptions, setOrder, tableNumberAuto } from 'store/reducers/order';
import InputTableNumber from 'ufood-x/components/Outlet/InputTableNumber';


const Outlet = () => {
	const dispatch = useDispatch();
	const navigate = useNavigation();
	const location = useLocation();
	const { state } = location || {};
	const { slug, type } = useParams();

  const queryParams = new URLSearchParams(window.location.search);
  const product_id = queryParams?.get('product_id');

  const { isNearBottom } = useNearBottom();
	const { isScrolled } = useScroll();

	const { showToast } = useToast();

	const user = useSelector((store) => store?.user);

	const { details: outlet, loading: isLoadingOutlet, selectedTag } = useSelector((store) => store.outlet);
	const { isLoadingVoucherGlobalList } = useSelector((store) => store?.voucher);

	const [isLoading, setIsLoading] = useState(false);

	const [isLoadingProduct, setIsLoadingProduct] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [products, setProducts] = useState({
		result: [],
		current_page: 0,
		total_pages: 1,
		total_records: 0,
		has_next: true,
	});

	const [cart, setCart] = useState(null);

	const [isShowTotalCart, setIsShowTotalCart] = useState(false);
	const [isShowSimpleProduct, setIsShowSimpleProduct] = useState(false);
	const [isShowComboProduct, setIsShowComboProduct] = useState(false);
	const [isShowCouponVoucherGlobal, setIsShowCouponVoucherGlobal] = useState(false);
	const [couponVoucherGlobalList, setCouponVoucherGlobalList] = useState([]);
	const [showVoucherDetail, setShowVoucherDetail] = useState({
		isOpen: false,
		data: null,
		type: null,
	});

	const [productSlug, setProductSlug] = useState(null);
	const [cartItem, setCartItem] = useState(null);

	const [isOpenBottomSheet, setIsOpenBottomSheet] = useState(false);

	const [isChangeStoreCart, setIsChangeStoreCart] = useState(false);

	const [isShowErrorDistance, setIsShowErrorDistance] = useState(false);
	const [isOpenFormAddress, setIsOpenFormAddress] = useState(false);
	const [isShowTableNumber, setIsShowTableNumber] = useState(false);

	const { keyword } = useSelector((store) => store.product);
	const [orderTypeList, setOrderTypeList] = useState(null);
	const { orderTypeOptions, isLoadingOrderTypeOptions, selectedOrderType, tableNumber } = useSelector((store) => store?.order);

	const handleGetStore = useCallback(async () => {
		if (isEmptyData(user?.token)) return;
		dispatch(
			handleGetStoreDetail({
				storeID: slug,
				latitude: user?.latitude,
				longitude: user?.longitude,
			}),
		);
	}, [slug, user?.token, user?.latitude, user?.longitude]);

	const handleGetProducts = async (props) => {
		console.log('handleGetProducts');
    	const { storeID, page, limit, isLoadMore = false, categoryID, keyword } = props;

    try {
		 !isLoadMore ? setIsLoadingProduct(true) : setIsLoadingMore(true);

      let url = `catalogs/listproducts?unquieid=${uniqueID}&storeID=${encodeValue(storeID)}`;
      if (!isEmptyData(categoryID)) {
        url += `&category=${categoryID}`
      }
      if (!isEmptyData(keyword)) {
        url += `&keyword=${keyword}`
      }
	  if (!isEmptyData(selectedOrderType)) {
        url += `&availabilityID=${selectedOrderType?.av_id}`
      }
      if (!isEmptyData(page)) {
        url += `&page=${page}`
      }
      if (!isEmptyData(limit)) {
        url += `&limit=${limit}`
      }

      const res = await axiosInstance.get(url, {
				headers: {
					Accept: 'application/json, text/plain, */*',
				},
			});
      if (res.data?.status === 'ok') {
        const { result = [], pagination } = res?.data || {};

        setProducts((prev) => {
          const newItems = isLoadMore ? result.filter((item) => !prev.result.some((p) => p.product_id === item.product_id)) : result;

          return {
            result: isLoadMore ? [...prev.result, ...newItems] : result,
            pagination,
          };
        });
			}
			!isLoadMore ? setIsLoadingProduct(false) : setIsLoadingMore(false);
      
		} catch (error) {
			console.log('error: ', error);
      		!isLoadMore ? setIsLoadingProduct(false) : setIsLoadingMore(false);
		}
	};

	const handleCart = async (data, isClose = true) => {
		console.log('handleCart');
		try {
			setIsLoading(true);
			let postData = {
				unquieid: uniqueID,
				availabilityID: deliveryId,
				availabilityName: 'Delivery',
				shopID: encodeValue(state?.storeID || outlet?.storeID),
			};
			if (data?.productType === 'Simple') {
				postData = {
					...postData,
					...data,
				};
			} else {
				postData = {
					...postData,
					...data,
					// productTotalPrice: data?.totalPrice,
					// productPrice: data?.price,
					comboset: JSON.stringify(data?.comboset),
				};
			}

			sendAnalyticsCustomEvent('add_to_cart', {
				customer_id: user?.customerID,
				value: postData?.productTotalPrice || postData?.price || 0,
				merchants_id: state?.storeID || outlet?.storeID,
				items: postData,
			});
			trackMetaPixelEvent('add_to_cart', {
				customer_id: user?.customerID,
				value: postData?.productTotalPrice || postData?.price || 0,
				merchants_id: state?.storeID || outlet?.storeID,
				items: postData,
			});

			const url = `cart/${data?.type === 'add' ? 'createCart' : 'updateCartItem'}`;
			const res = await axiosInstance.post(url, qs.stringify(postData), authHeaders());
			if (res?.data?.status === 'ok') {
				isClose && setCartItem(null);
				isClose && handleCloseBottomSheet();
				await handleGetCart();
			}
			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoading(false);

    //   logError(error, {feature: "handleCart"});
		}
	};

	const handleRemoveCart = async () => {
		console.log('handleRemoveCart');
		try {
			setIsLoading(true);
			const postData = {
				unquieid: uniqueID,
			};
			const res = await axiosInstance.post(`cart/removeCart`, qs.stringify(postData), authHeaders());
			if (res?.data?.status === 'ok') {
				setCart(null);
			}
			if (productSlug) {
				console.log('handleGetProductDetail');
				await handleGetProductDetail(productSlug, true);
			}
			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoading(false);

    //   logError(error, {feature: "handleRemoveCart"});
		}
	};

	const handleGetCart = useCallback(async () => {
		console.log('handleGetCart');
		try {
			setIsLoading(true);
			const url = `cart/loadCartDetails?unquieid=${uniqueID}&availabilityID=${deliveryId}&storeID=${state?.storeID || outlet?.storeID}`;
			const res = await axiosInstance.get(url, {
				headers: {
					Accept: 'application/json, text/plain, */*',
					...authHeaders().headers,
				},
			});
			if (res?.data?.status === 'ok') {
				setCart(res?.data?.result || null);
			}
			if (res?.data?.message === 'There are no items in your cart') {
				setCart(null);
			}
			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoading(false);

    //   logError(error, {feature: "handleGetCart"});
		}
	}, [state?.storeID, outlet?.storeID]);

	useEffect(() => {
		sendAnalyticsPageView('merchant_session');
	}, []);

	useEffect(() => {
		sendAnalyticsEvent('Merchant Detail', 'merchant_detail', outlet?.storeName);
	}, []);

	useEffect(() => {
		if (user?.customerID && products?.result?.length) {
			sendAnalyticsCustomEvent('detail_merchant', {
				customer_id: user?.customerID,
				merchants_id: state?.storeID || outlet?.storeID,
				merchants_name: state?.storeName || outlet?.storeName,
				detail_merchants_items: products?.result,
			});
			trackMetaPixelEvent('detail_merchant', {
				customer_id: user?.customerID,
				merchants_id: state?.storeID || outlet?.storeID,
				merchants_name: state?.storeName || outlet?.storeName,
				detail_merchants_items: products?.result,
			});
		}
	}, [user?.customerID, products?.result?.length]);

	useEffect(() => {
		handleGetStore();
		handleGetCart();
	}, [user?.customerID, state?.storeID, outlet?.storeID]);
  
  
	useEffect(() => {
		const storeID = state?.storeID || outlet?.storeID;
 		if (isEmptyData(storeID) || isEmptyData(user?.token) || isEmptyData(selectedOrderType) || isLoadingOrderTypeOptions || !orderTypeList) return;
    let data = {
      storeID,
    }
    
    if (!isEmptyData(selectedTag?.pro_cate_primary_id)) {
      data.categoryID = selectedTag?.pro_cate_primary_id;
    }

    if (!isEmptyData(keyword)) {
      data.keyword = keyword
    }

    handleGetProducts(data);
	}, [state?.storeID, outlet?.storeID, user?.token, selectedTag?.pro_cate_primary_id, keyword, type, selectedOrderType]);

  useEffect(() => {
		const storeID = state?.storeID || outlet?.storeID;
 		if (isEmptyData(storeID) || isEmptyData(user?.token) || isEmptyData(selectedOrderType) || isLoadingOrderTypeOptions || !orderTypeList) return;
    if (!isNearBottom || Number(products?.pagination?.current_page) >= Number(products?.pagination?.total_pages)) return;

		const nextPage = Number(products?.pagination?.current_page) + 1;

    let data = {
      storeID,
      companyID: user?.companyID,
      page: nextPage,
      limit: Number(products?.pagination?.items_per_page) || 10,
      isLoadMore: true,
    }
    
    if (!isEmptyData(selectedTag?.pro_cate_primary_id)) {
      data.categoryID = selectedTag?.pro_cate_primary_id;
    }

    if (!isEmptyData(keyword)) {
      data.keyword = keyword
    }

    handleGetProducts(data);
  }, [isNearBottom, state?.storeID, outlet?.storeID, user?.token, selectedTag?.pro_cate_primary_id, keyword, selectedOrderType])
  

	useEffect(() => {
		if (!cart?.item?.length || isOpenBottomSheet) return;
		setIsShowTotalCart(true);
	}, [cart?.item?.length, isOpenBottomSheet, isShowErrorDistance]);

	useEffect(() => {
		if (Number(outlet?.distance) <= MINIMUM_DISTANCE && orderTypeList?.orderType === 'delivery') {
			setIsShowErrorDistance(true);
			setIsShowTotalCart(false);
		} else {
			setIsShowErrorDistance(false);
		}
	}, [outlet?.distance, orderTypeList]);

	useEffect(() => {
		if (isEmptyData(outlet?.storeID) || isEmptyData(product_id)) return;
		handleGetProductDetail({ product_id, product_slug: product_id });
	}, [product_id, outlet?.storeID]);

	useEffect(() => {
		if (isLoadingOrderTypeOptions || isEmptyData(orderTypeOptions) || !orderTypeList) return;
		const find = orderTypeOptions?.find((i) => cleanText(i?.av_name) === type);
		if (isEmptyData(find)) {
			let avName = null
			if(orderTypeList?.availabilityName){
				avName = cleanText(orderTypeList?.availabilityName)
			} else if (orderTypeList?.[0]?.name){
				avName = cleanText(orderTypeList?.[0]?.name)
			} else {
				showToast('error', 'Tipe Order Tidak Tersedia', 2000).then(() => {
					return navigate.push('/');
				});
			}

			let newSelected = orderTypeOptions.find((t) => cleanText(t?.av_name) === avName);

			dispatch(
				setOrder({
					selectedOrderType: newSelected
				})
			);

			return navigate.replace(`/outlet/${slug}/${avName}`);
		}	

		if (type === 'dinein' && isEmptyData(tableNumber?.table_number)) {
			if (outlet?.dinein_qr_code) {
				setIsShowTableNumber(true);
				return;
			}
			if (isEmptyData(outlet?.dinein_qr_code)) {
				dispatch(
					tableNumberAuto({
						outletId: Number(outlet?.storeID),
						brandId: Number(outlet?.brand_id),
					})
				);
			}
		}

		dispatch(
			setOrder({
				selectedOrderType: find
			})
		);
	}, [isLoadingOrderTypeOptions, orderTypeOptions, orderTypeList]);

	const handleCloseTableNumber = () => {
		setIsShowTableNumber(false);
	};

	const handleGetProductDetail = async (product, removeCart = false) => {
		if (!product?.product_slug && !product?.product_id) return;

		try {
			if (!removeCart && cart?.store?.storeID && cart?.store?.storeID !== outlet?.storeID) {
				setProductSlug(product);
				return setIsChangeStoreCart(true);
			}
			setIsLoading(true);
			const url = `catalogs/productdetails?unquieid=${uniqueID}&storeID=${encodeValue(state?.storeID ?? outlet?.storeID)}&productID=${product?.product_id}`;
			const res = await axiosInstance.get(url, {
				headers: {
					Accept: 'application/json, text/plain, */*',
					...authHeaders().headers,
				},
			});
			if (res.data?.status === 'ok') {
				const product = res.data?.result || null;
				setCartItem(product);
				if (product?.product_type === '1') {
					setIsShowSimpleProduct(true);
				}
				if (product?.product_type === '2') {
					setIsShowComboProduct(true);
				}
				setIsOpenBottomSheet(true);
				setIsShowTotalCart(false);
			}
			if (res?.data?.status === 'error') {
				showToast('warning', 'Product not found', 1000);
			}
			setProductSlug(null);
			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoading(false);

    //   logError(error, {feature: "handleGetProductDetail"});
		}
	};

	const handleFavorite = useCallback(async () => {
		if (!user?.customerID) return;
		console.log('handleFavorite');
		try {
			setIsLoading(true);

			sendAnalyticsCustomEvent(Boolean(Number(outlet?.favorite || outlet?.favourite)) ? 'homepage_unfavorite' : 'homepage_favorite', {
				customer_id: user?.customerID,
				...outlet,
			});

			const dataPost = {
				unquieid: uniqueID,
				shopID: encodeValue(outlet?.storeID),
				customerID: encodeValue(user?.customerID),
			};
			const url = `store/${Boolean(Number(outlet?.favorite || outlet?.favourite)) ? 'removeFavourite' : 'addFavourite'}`;
			const res = await axiosInstance.post(url, qs.stringify(dataPost), authHeaders());
			if (res?.data?.status === 'ok') {
				handleGetStore();
				trackMetaPixelEvent('homepage_favorite', {
					customer_id: user?.customerID,
					favorite_items: [
						{
							favorite_id: res?.data?.data?.fav_id,
							merchants_id: outlet?.storeID,
							merchants_name: outlet?.storeName,
							merchants_distance: `${outlet?.distance} KM`,
							merchants_rating: outlet?.rating,
						}
					]
				})
			}
			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
      showToast('warning', error?.message || 'Silahkan Login Terlebih Dahulu', 1000);
			setIsLoading(false);

    //   logError(error, {feature: "handleFavorite"});
		}
	}, [outlet, user]);

	const handleCloseBottomSheet = () => {
		console.log('handleCloseBottomSheet');
		setIsOpenBottomSheet(false);
		setIsShowTotalCart(true);
		setIsShowSimpleProduct(false);
		setIsShowComboProduct(false);
		setIsChangeStoreCart(false);
		setIsShowCouponVoucherGlobal(false);
		setCouponVoucherGlobalList([]);
	};

	const handleRemoveCartAndGetProduct = () => {
		console.log('handleRemoveCartAndGetProduct');
		handleCloseBottomSheet();
		handleRemoveCart();
	};

	const handleToSummary = () => {
		console.log('handleToSummary');
		if (user?.is_b2b && (isEmptyData(user?.firstName) || isEmptyData(user?.primary_phone) || isEmptyData(user?.email))) {
			return setIsOpenFormAddress(true);
		}
		navigate.push('/summary');
	};

	const handleCloseBottomSheetLocation = () => {
		setIsShowErrorDistance(false);
		setIsShowTotalCart(true);
	};

	const handleVoucherDetail = (isShow, data, type = null) => {
		if (isShow) {
			setShowVoucherDetail({
				isOpen: true,
				data,
				type,
			});
		} else {
			setShowVoucherDetail({
				isOpen: false,
				data: null,
				type: null,
			});
		}
	};

	const filteredProduct = useMemo(() => {
    return products?.result;
	}, [products?.result]);

	const groupedColumns = useMemo(() => {
		if (!filteredProduct?.length) return [];

		return Array.from({ length: Math.ceil(filteredProduct.length / 2) }, (_, i) => {
			const group = [i * 2, i * 2 + 1].filter((idx) => idx < filteredProduct.length);
			const names = group?.map((idx) => filteredProduct?.[idx]?.product_name);
			const longest_name = names?.reduce((longest, name) => (name?.length > longest?.length ? name : longest), '');
			return { group, names, longest_name };
		});
	}, [filteredProduct]);

	const handleCloseFormAddress = () => {
		setIsOpenFormAddress(false);
	};

	const formAddressProps = useMemo(() => {
		return {
			nextPage: '/summary',
			onClose: handleCloseFormAddress,
		};
	}, []);

	const noOutletProps = {
		isOpen: isShowErrorDistance,
		onClose: handleCloseBottomSheetLocation,
		sameLocation: true,
	};

	const handleGetOrderType = async (outletId = null) => {
		if (isEmptyData(outletId)) return;
		try {
			setIsLoading(true);
			const url = `availability/list`;
			const res = await axiosInstance.post(
				url,
				{ outlet_id: outletId },
				{
					headers: {
						Accept: 'application/json',
						...authHeaders().headers
					},
				},
			);

			if (res?.status === 200) {
				let avability = null;
				const data = res?.data?.data || [];
				const orderType = data?.map((d) => {
					const name = d?.av_name?.toLowerCase();
					if (cleanText(name) === 'dinein') return null;
					return {
						...d,
						label: name,
						name: d?.av_name,
					};
				}).filter(Boolean);
				setOrderTypeList(orderType);

				if (orderType.length === 1) {
					avability = orderType[0];
				}

				if (!avability) {
					avability = orderType.find((d) => d.label === 'delivery');
				}

				if (!isEmptyData(avability)) {
					setOrderTypeList(() => {
						return {
							orderType: avability?.label,
							availabilityID: avability?.av_id,
							availabilityName: avability?.av_name,
						};
					});
				}
			}
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (!state?.storeID && !outlet?.storeID) return;
		const storeID = state?.storeID || outlet?.storeID;
		handleGetOrderType(storeID);
		dispatch(
			getOrderTypeOptions({
				storeID: outlet?.storeID,
			}),
		);
	}, [state?.storeID, outlet?.storeID]);

	const couponVoucherGlobalProps = {
		classNameParent: '!w-[93%] mx-4',
		classNameBody: '!py-1',
		classNameIcon: '!w-10',
		classNameLabel: '!text-xs',
		classNameDesc: '!text-xxs pt-1',
		vouchers: outlet?.voucher_global || [],
		outlet: outlet,
    callback: () => setIsShowTotalCart(false),
    onClose: () => setIsShowTotalCart(true),
	};

	const isLoadingProps = isLoading || isLoadingVoucherGlobalList || isLoadingOutlet || isLoadingOrderTypeOptions;

  return (
		<>
			{isLoadingProps && <Loader overlay />}
			<div className='h-screen w-full flex justify-center items-center'>
				<div className='h-screen w-full max-w-lg'>
					<Header isScrolled={isScrolled} isOpenBottomSheet={isOpenBottomSheet} state={state} outlet={outlet} handleFavorite={handleFavorite} />
					<Detail state={state} outlet={outlet} slug={slug} />
					<CouponVoucherGlobal {...couponVoucherGlobalProps} />
          <SearchMenu />
					<div className={`mx-4 ${outlet?.voucher_global?.length ? 'mt-4' : ''} ${cart && 'pb-28'}`}>
						<div className='text-base text-gray-800 font-semibold'>Pilihan Utama</div>
						<Tags />
						{isLoadingProduct ? (
							<div className='w-full h-[calc(100vh/2)] flex justify-center items-center bg-red-500}'>
								<LoaderIcon />
							</div>
							) : (
							<div className="mt-4">
							<ProductGrid
								products={filteredProduct}
								outlet={outlet}
								cart={cart}
								handleCart={handleCart}
								handleGetProductDetail={handleGetProductDetail}
							/>
							</div>
						)}
            {isLoadingMore && (
              <div className='flex justify-center !mt-1'>
                <LoaderIcon />
              </div>
            )}
					</div>
					{isShowTotalCart && !isShowErrorDistance && !isOpenFormAddress && user?.age_verified !== AGE_VERIFICATION_STATUS.PROMPT && (
						<Footer position='fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-lg !z-[6]' id='cart'>
							<div className={`bg-white p-4 shadow-custom transition-transform duration-1000 ease-in-out ${cart ? 'translate-y-0 relative' : 'translate-y-full hidden'}`}>
								<div className='items-center hidden'>
									<DiscountIcon />
									<div className='pl-2 text-gray-900 text-xs'>Yay, kamu menghemat 10k. Tambahkan lebih banyak dan hemat hingga 50k!</div>
								</div>
								<button
									className='mt-2 w-full bg-[var(--rose-violet)] text-white flex justify-between font-normal text-sm p-3 border-0 items-center'
									onClick={() => {
										sendAnalyticsEvent('Click Button Summary', 'merchant_item_in_cart', state?.storeName || outlet?.storeName);
										handleToSummary();
									}}
									id='merchant_item_in_cart'>
									<div>{cart?.totalItem} item di keranjang</div>
									<div>{formatRupiah(parseInt(cart?.subTotal || 0))}</div>
								</button>
							</div>
						</Footer>
					)}
					{isChangeStoreCart && (
						<Footer
							position='fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl'
							id='isChangeStoreCart'
							onTouchOutside={() => {
								setIsChangeStoreCart(false);
								setProductSlug(null);
							}}>
							<div className={`bg-white p-4 rounded-xl shadow-custom transition-transform duration-1000 ease-in-out ${isChangeStoreCart ? 'translate-y-0 relative' : 'translate-y-full hidden'}`}>
								<div className='flex justify-center'>
									<div className='bg-gray-300 h-1.5 w-10 rounded-full' />
								</div>
								<div className='items-center flex justify-center mt-8'>
									<WishtlingIcon className='fill-[var(--rose-violet)]' />
								</div>
								<div className='my-5 text-center'>
									<div className='text-gray-900 text-sm font-semibold'>Apakah Anda ingin membeli dari restoran ini?</div>
									<div className='text-gray-900 text-xs pt-2'>Kami perlu mengosongkan item di keranjang Anda saat ini.</div>
								</div>
								<div className='flex justify-between mt-2 gap-4'>
									<button
										className='w-full bg-white text-[var(--rose-violet)] border-[var(--rose-violet)] font-semibold text-sm p-3 items-center border'
										onClick={() => {
											setIsChangeStoreCart(false);
											setProductSlug(null);
										}}
										id='merchant_change_cart_cancel'>
										Batal
									</button>
									<button onClick={handleRemoveCartAndGetProduct} className='w-full bg-[var(--rose-violet)] text-white font-semibold text-sm p-3 items-center border-0' id='merchant_change_cart_confirm'>
										Ya, Tentu
									</button>
								</div>
							</div>
						</Footer>
					)}
					{isOpenBottomSheet && (
						<BottomSheet
							initialFocusRef={false}
							open={isOpenBottomSheet}
							onDismiss={handleCloseBottomSheet}
							snapPoints={({ minHeight, maxHeight }) => {
								return [minHeight, maxHeight * 0.75];
							}}>
							{isShowSimpleProduct && <ProductSimple product={cartItem} cart={cart} handleCart={handleCart} setCartItem={setCartItem} />}
							{isShowComboProduct && <ProductCombo product={cartItem} cart={cart} handleCart={handleCart} setCartItem={setCartItem} />}
							{isShowCouponVoucherGlobal && <CouponVoucherGlobalList vouchers={couponVoucherGlobalList || outlet?.voucher_global || []} isHiddenButton={true} handleVoucherDetail={handleVoucherDetail} />}
						</BottomSheet>
					)}
					<NoOutlet {...noOutletProps} />
					<BottomSheet open={isOpenFormAddress} onDismiss={handleCloseFormAddress}>
						<Address {...formAddressProps} />
					</BottomSheet>
					<InputTableNumber open={isShowTableNumber} onClose={handleCloseTableNumber} />
				</div>
			</div>
		</>
	);
};

export default Outlet;